const SellerReviewGoodIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFDD67"
      />
      <path
        d="M11.9999 19.2096C10.5564 19.2098 9.14877 18.7598 7.97302 17.9223C6.79728 17.0848 5.91198 15.9015 5.4404 14.5372C5.40044 14.4341 5.38166 14.324 5.38518 14.2135C5.3887 14.103 5.41445 13.9944 5.46089 13.8941C5.50733 13.7937 5.57351 13.7038 5.65548 13.6296C5.73744 13.5554 5.83352 13.4985 5.93796 13.4623C6.04241 13.4261 6.15308 13.4113 6.26338 13.4188C6.37367 13.4263 6.48133 13.4559 6.57992 13.5059C6.6785 13.5559 6.766 13.6253 6.83719 13.7099C6.90837 13.7945 6.96178 13.8925 6.99423 13.9982C7.35222 15.0412 8.02708 15.9464 8.92453 16.5872C9.82198 17.228 10.8972 17.5725 11.9999 17.5725C13.1027 17.5725 14.1779 17.228 15.0754 16.5872C15.9728 15.9464 16.6477 15.0412 17.0057 13.9982C17.0381 13.8925 17.0915 13.7945 17.1627 13.7099C17.2339 13.6253 17.3214 13.5559 17.42 13.5059C17.5186 13.4559 17.6262 13.4263 17.7365 13.4188C17.8468 13.4113 17.9575 13.4261 18.0619 13.4623C18.1664 13.4985 18.2625 13.5554 18.3444 13.6296C18.4264 13.7038 18.4926 13.7937 18.539 13.8941C18.5854 13.9944 18.6112 14.103 18.6147 14.2135C18.6182 14.324 18.5995 14.4341 18.5595 14.5372C18.0879 15.9015 17.2026 17.0848 16.0269 17.9223C14.8511 18.7598 13.4435 19.2098 11.9999 19.2096Z"
        fill="#B26D3C"
      />
      <path
        d="M15.977 10.6519C16.8481 10.6519 17.5542 9.94579 17.5542 9.07476C17.5542 8.20373 16.8481 7.49762 15.977 7.49762C15.106 7.49762 14.3999 8.20373 14.3999 9.07476C14.3999 9.94579 15.106 10.6519 15.977 10.6519Z"
        fill="#B26D3C"
      />
      <path
        d="M8.02294 10.6519C8.89398 10.6519 9.60009 9.94579 9.60009 9.07476C9.60009 8.20373 8.89398 7.49762 8.02294 7.49762C7.15191 7.49762 6.4458 8.20373 6.4458 9.07476C6.4458 9.94579 7.15191 10.6519 8.02294 10.6519Z"
        fill="#B26D3C"
      />
    </svg>
  );
};

export { SellerReviewGoodIcon };
